module.exports = __webpack_public_path__ + "img/31-ABITO-BRENDA-U-COLORI-GARZA-COLORI-RETE12.2b38ea8f.jpg";